import React, { Component } from 'react';
import GenericErrorPage from './GenericErrorPage';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { 
        hasError: false,
      };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
    
    render() {
      if (this.state.hasError) {
        return (
          <div className={'generic-error-page'} style={{marginTop: 100}}>
            <img src={'https://res.cloudinary.com/verb-prod/image/upload/v1548710177/verb-error-cat_hwtncs.png'} />
            <div className={'heading-container'}>
              <h2>Please try refreshing the page.</h2>
              <div className={'error-text'}>
                {'An error has occurred and has been recorded for our team to investigate.'}
              </div>
           </div>
          </div>)
      }
  
      return this.props.children;
    }
}

export default ErrorBoundary;